<template>
    <MenuItemContainer :url="url"
                       class="review-container">
        <div class="img-container">
            <img :src="logo_url"
                 :alt="name"
                 :title="name">
        </div>
        <div class="review-content">
            <div class="review-name">
                {{ name }}
            </div>
            <div class="d-flex align-items-center">
                <div class="review-score">
                    {{ score }}
                </div>
                <MenuStars :score="Number(score)"
                           :starsCount="STARS_COUNT" />
            </div>
        </div>
    </MenuItemContainer>
</template>

<script setup lang="ts">
    import MenuItemContainer from '../components/MenuItemContainer.vue';
    import { INavigationReview } from '../types/menuTypes';
    import MenuStars from '../components/MenuStars.vue';

    defineProps<INavigationReview>();

    const STARS_COUNT = 5;
</script>

<style scoped lang="scss">
@use "@/sass/partials/variables" as legacyVariables;
@use "@/sass/partials/mixins" as mixins;

.review-container {
    display: flex;
    align-items: center;
    padding: 4px 14px;

    .img-container {
        display: flex;
        align-items: center;
        margin-right: 10px;

        img {
            width: 100px;
            height: 20px;
        }
    }

    .review-content {
        display: flex;
        overflow: hidden;
        flex: 1;
        flex-direction: column;

        .review-name {
            @include mixins.one-line-clamp;
            width: 130px;
            font-size: 16px;
            font-weight: 700;

            @media (min-width: legacyVariables.$navigation-menu-breakpoint) {
                font-size: 14px;
            }
        }

        .review-score {
            margin-right: 6px;
            font-size: 18px;
            font-weight: 700;
            line-height: 18px;
        }
    }

    .stars-container {
        position: relative;
        display: flex;
        height: 18px;
        align-items: center;
        font-size: 12px;

        .stars-active {
            position: absolute;
            overflow: hidden;
            color: legacyVariables.$star-rating-active;
            white-space: nowrap;
        }

        .stars-inactive {
            color: legacyVariables.$star-rating-active;
            white-space: nowrap;
        }
    }
}

.mobile-nav {
    .review-content {
        .review-name {
            width: 100%;
        }
    }
}

.dark-theme {
    .review-container {
        .img-container {
            img {
                filter: grayscale(1) invert(1) brightness(300%);
            }
        }
    }
}
</style>
